import React, { useState, useEffect, useRef } from 'react';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';

import './InfoPage.css';

import logoImage from './../../image/logo.svg';
import btnIcon from './../../image/contact-btn-icon.svg';
import btnIconActive from './../../image/active-btn.svg';

import imageOne from './../../image/001.jpg';
import imageTwo from './../../image/002.jpg';
import imageThree from './../../image/003.jpg';
import imageFour from './../../image/004.jpg';

const InfoPage = () => {
    const [isImageActive, setIsImageActive] = useState(false);
    const [isLocationActive, setIsLocationActive] = useState(false);

    const imageBtnRef = useRef(null);
    const locationBtnRef = useRef(null);

    // автоматический скролл
    useEffect(() => {
        if (isImageActive && imageBtnRef.current) {
            imageBtnRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [isImageActive]);

    // автоматический скролл
    useEffect(() => {
        if (isLocationActive && locationBtnRef.current) {
            locationBtnRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [isLocationActive]);

    const handleImageClick = () => {
        setIsImageActive(!isImageActive);
    };

    const handleLocationClick = () => {
        setIsLocationActive(!isLocationActive);
    };

    return (
        <div className='info__wrapper'>
            <div className='info__container'>
                <div className='info__logo'>
                    <img src={logoImage} alt='Logo' />
                </div>

                <div className='info__group_items'>
                    <div className='info__group_item'>
                        <h3 className='info__item_title'>Авторская кухня</h3>
                        <p className='info__item_text'>
                            Погрузитесь в мир паназиатской кухни с авторскими
                            рецептами от нашего шеф-повара
                        </p>
                    </div>

                    <div className='info__group_item'>
                        <h3 className='info__item_title'>Карта бара</h3>
                        <p className='info__item_text'>
                            Широкий выбор из оригинальных коктейлей и изысканной
                            классики, где для каждого найдётся что-то особенное
                        </p>
                    </div>

                    <div className='info__group_item'>
                        <h3 className='info__item_title'>Чайная коллекция</h3>
                        <p className='info__item_text'>
                            В чайной карте мы объединили фирменные рецепты и
                            лучшие образцы китайских чаёв
                        </p>
                    </div>

                    <div className='info__group_item'>
                        <h3 className='info__item_title'>VIP зона</h3>
                        <p className='info__item_text'>
                            Уединитесь в VIP-комнате, играйте в настольные игры
                            и Playstation 5, a мы позаботимся о вашем отдыхе
                        </p>
                    </div>
                </div>

                <div className='info__btns'>
                    <div
                        ref={locationBtnRef}
                        className={
                            isLocationActive ? 'info__btn_active' : 'info__btn'
                        }
                        onClick={handleLocationClick}
                    >
                        <p>Как добраться</p>
                        <img
                            src={isLocationActive ? btnIconActive : btnIcon}
                            className='info__btn_icon'
                        />
                    </div>
                </div>

                {isLocationActive && (
                    <YMaps>
                        <div
                            style={{
                                width: '100%',
                                height: '300px',
                                marginBottom: '10px',
                            }}
                        >
                            <Map
                                defaultState={{
                                    center: [55.687715, 37.474507],
                                    zoom: 15,
                                }}
                                width='100%'
                                height='300px'
                            >
                                <Placemark geometry={[55.687715, 37.474507]} />
                            </Map>
                        </div>
                    </YMaps>
                )}
                <div className='info__btns'>
                    <div
                        ref={imageBtnRef}
                        className={
                            isImageActive ? 'info__btn_active' : 'info__btn'
                        }
                        onClick={handleImageClick}
                    >
                        <p>Галерея</p>
                        <img
                            src={isImageActive ? btnIconActive : btnIcon}
                            className='info__btn_icon'
                        />
                    </div>
                </div>
                {isImageActive && (
                    <div className='info__image_items'>
                        <img src={imageOne} />
                        <img src={imageTwo} />
                        <img src={imageThree} />
                        <img src={imageFour} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default InfoPage;
